export default __webpack_public_path__ + "static/media/yellow.f62da488.png";